<script>

import axios from "axios"
// import { formatNumber } from "./utils.js"
import { cart, lang, comment, currency } from "./store.js"
// import { onMount } from "svelte";
let loading = false

async function checkout(){
    loading = true
    // updateNote()
    await new Promise(resolve => setTimeout(resolve, 300));
    loading = false
    // alert("now")
    window.location.href = "/" + $lang + "/checkout"

}

function formatNumber(num, currency = "eur", sign = false){

    let fr = 0

    switch (currency) {
        case "eur":
            currency = "€"
            fr = 2
            break;
        case "czk":
            currency = "Kč"
            fr = 0
            break;
    }

    if(num == null){
        return ""
    }else if(!sign){
        num = new Intl.NumberFormat('de-DE', { maximumFractionDigits: fr, minimumFractionDigits: fr }).format(num);
        return num
    }
    else{
        num = new Intl.NumberFormat('de-DE', { maximumFractionDigits: fr, minimumFractionDigits: fr }).format(num) + " " + currency;
        return num
    }
}

function updateNote(){
    let data = {
        comment: $comment
    }
    axios.post('/api/change-comment',data,{withCredentials: true})
}

function plus(i){
    $cart[i]["amount"] = parseInt($cart[i]["amount"]) + 1
    axios.get('/api/cart-change/' + $cart[i]["id"] + '/' + $cart[i]["amount"],{withCredentials: true})
}

function minus(i){
    if($cart[i]["amount"]>1){
        $cart[i]["amount"] = parseInt($cart[i]["amount"]) - 1
    }
    else{
        $cart[i]["amount"] = 1
    }
    axios.get('/api/cart-change/' + $cart[i]["id"] + '/' + $cart[i]["amount"],{withCredentials: true})
}

function remove(i){

    axios.get('/api/cart-remove/' + $cart[i]["id"],{withCredentials: true})
    if (i > -1) {
        $cart.splice(i, 1);
        $cart = $cart
    }
}


function nullText(val){
    if (val == null){
        return ""
    }else{
        return val
    }
}

let total = 0
$:{
    for (let x = 0; x < $cart.length; x++) {
        if(x === 0) total = 0
        total += parseFloat($cart[x]["amount"])*parseFloat($cart[x]["price"])
    }
}

function continueShopping(){
    modal = false
}

</script>


{#if $cart.length !== 0}
<!-- MOBILE -->
{#each $cart as c, i}
<div class="columns is-mobile mt-2 is-hidden-tablet">
    <div class="column" style="max-width:100px">
        <a href="/{$lang}/{ c.link }">
            <figure class="image">
                <picture>
                    <source type="image/webp" srcset="/img/p/440-{ c.img }.webp">
                    <source type="image/jpeg" srcset="/img/p/440-{ c.img }.jpg">
                    <img src="/img/p/440-{ c.img }.jpg" alt="img">
                </picture>
                <!-- <img src="/img/p/440-{ c.img }" alt="{ c.title }"> -->
            </figure>
        </a>
    </div>
    <div class="column">
        <div class="">
            <a href="/{$lang}/{ c.link }" class="has-text-weight-bold">{ c.title }</a>
        </div>
        {#if c.variation1_title }
        <div class="mt-1 mb-2 is-size-7">
            { nullText(c.variation1_title) }{#if c.variation2_title}, { nullText(c.variation2_title) }{/if}
        </div>
        {/if}
        {#if c.personification }
        <div class="mt-1 mb-2 is-size-7">
            { nullText(c.personification) }
        </div>

        {/if}
        <div class="mt-1 mb-2">
            { formatNumber(c.price, $currency, true) }
        </div>
        <div class="level is-mobile is-justify-content-flex-start">
            <div class="level-left">
                <div class="control has-icons-left has-icons-right" style="width:110px">
                    <input class="input has-text-centered" type="text" bind:value={c.amount}>
                    <span class="icon is-small is-left is-clickable" on:click={()=>{minus(i)}}>
                        <img src="/img/icons/minus-circle.svg" class="image is-16x16" alt="-">
                    </span>
                    <span class="icon is-small is-right is-clickable" on:click={()=>{plus(i)}}>
                        <img src="/img/icons/plus-circle.svg" class="image is-16x16" alt="+">
                    </span>
                </div>
            </div>
            <div class="level-left is-size-7 ml-2">
                <a href="/" class="is-underlined" on:click|preventDefault={()=>{remove(i)}}>{($lang == "cs" ? 'odebrat' : 'remove')}</a>
            </div>
        </div>
    </div>
</div>
{/each}

<!-- DESKTOP -->

<div class="columns cart-headline mx-auto pt-5 is-hidden-mobile" style="max-width:750px">
    <div class="column pl-0">{($lang == "cs" ? 'Produkt' : 'Product')}</div>
    <div class="column div-price has-text-right">{($lang == "cs" ? 'Cena' : 'Price')}</div>
    <div class="column div-amount has-text-centered">{($lang == "cs" ? 'Množství' : 'Quantity')}</div>
    <div class="column div-total has-text-right pr-0">{($lang == "cs" ? 'Celkem' : 'Total')}</div>
</div>

{#each $cart as c, i}
<div class="columns mx-auto mt-2 is-hidden-mobile" style="max-width:750px">
    <div class="column pl-0">
        <div class="media">
            <div class="media-image">
                <a href="/{$lang}/{ c.link }">
                    <figure class="image" style="width:80px;height:80px">
                        <picture>
                            <source type="image/webp" srcset="/img/p/440-{ c.img }.webp">
                            <source type="image/jpeg" srcset="/img/p/440-{ c.img }.jpg">
                            <img src="/img/p/440-{ c.img }.jpg" alt="img">
                        </picture>
                    </figure>
                </a>
            </div>
            <div class="media-content ml-2">
                <div class="">
                    <a href="/{$lang}/{ c.link }">{ c.title }</a>
                </div>
                {#if c.variation1_title }
                <div class="is-size-7 mt-1 mb-2">
                    { nullText(c.variation1_title) }{#if c.variation2_title}, { nullText(c.variation2_title) }{/if}
                </div>
                {/if}
                {#if c.personification }
                <div class="is-size-7 mt-1 mb-2">
                    { nullText(c.personification) }
                </div>
                {/if}
            </div>
        </div>
    </div>
    <div class="column div-price has-text-right">{formatNumber(c.price, $currency, true)}</div>
    <div class="column div-amount has-text-centered">
        <div class="control has-icons-left has-icons-right" style="width:110px;margin-left:auto;margin-right:auto">
            <input class="input has-text-centered" type="text" bind:value={c.amount}>
            <span class="icon is-small is-left is-clickable" on:click={()=>{minus(i)}}>
                <img src="/img/icons/minus-circle.svg" class="image is-16x16" alt="-">
            </span>
            <span class="icon is-small is-right is-clickable" on:click={()=>{plus(i)}}>
                <img src="/img/icons/plus-circle.svg" class="image is-16x16" alt="+">
            </span>
        </div>
        <div class="is-size-7 mt-2">
            <a href="/" class="is-underlined" on:click|preventDefault={()=>{remove(i)}}>{($lang == "cs" ? 'odebrat' : 'remove')}</a>
        </div>
    </div>
    <div class="column div-total has-text-right pr-0">{formatNumber(c.amount*c.price, $currency, true)}</div>
</div>
{/each}

<!-- SUBTOTAL -->
<div class="level is-mobile subtotal mt-5 py-3 mx-auto is-size-5 has-text-weight-bold" style="max-width:750px">
    <div class="level-left">
        {($lang == "cs" ? 'Mezisoučet' : 'Subtotal')}
    </div>
    <div class="level-right">
        {formatNumber(total, $currency, true)}
    </div>
</div>


<div class="mx-auto mt-5 has-text-centered">
    <a href="/{$lang}/checkout" on:click|preventDefault={checkout} class="button is-belle-full {(loading ? 'is-loading' : '')}">{($lang == "cs" ? 'Přejít k pokladně' : 'Continue to checkout')}</a>
    <div class="my-2">{($lang == "cs" ? 'nebo' : 'or')}</div>
    <a href="/{($lang == "cs" ? 'cs' : '')}" class="is-underlined is-size-7">{($lang == "cs" ? 'Pokračovat v nákupu' : 'Continue shopping')}</a>
</div>

<div class="mx-auto mt-5" style="max-width:500px">
    <label class="label has-text-weight-normal">
        {($lang == "cs" ? 'Nechte nám zprávu k objednávce' : 'Add note for your order')}
    </label>
    <textarea class="textarea" on:blur={updateNote} bind:value={$comment}></textarea>
</div>

{:else}
<div class="mx-auto mt-4 has-text-centered" >
    <div class="is-size-5 mt-5 mb-5">
        {($lang == "cs" ? 'V košíku nemáte žádné produkty' : 'There are no products in the cart')}

    </div>
    <a href="/{($lang == "cs" ? 'cs' : '')}" class="is-underlined">{($lang == "cs" ? 'Pokračovat v nákupu' : 'Continue shopping')}</a>
</div>
{/if}